
namespace GeniuzPOS.PosShift {
    import fld = LogFuctionLvAppRow.Fields;


    @Serenity.Decorators.registerClass()
    export class LogFuctionLvAppGrid extends Serenity.EntityGrid<LogFuctionLvAppRow, any> {
        protected getColumnsKey() { return LogFuctionLvAppColumns.columnsKey; }
        protected getDialogType() { return LogFuctionLvAppDialog; }
        protected getIdProperty() { return LogFuctionLvAppRow.idProperty; }
        protected getInsertPermission() { return LogFuctionLvAppRow.insertPermission; }
        protected getLocalTextPrefix() { return LogFuctionLvAppRow.localTextPrefix; }
        protected getService() { return LogFuctionLvAppService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.CreateDate).init = w => {

                (w as Serenity.DateEditor).valueAsDate = new Date(new Date().setDate(new Date().getDate()-6));

                let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
                endDate.valueAsDate = new Date(Date.now());
            };

         


            return filters;
        }

        protected getButtons() {
			var button = super.getButtons();

            button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
            
            button.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: LogFuctionLvAppService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
                
                button.push(
                    {
                        title: Q.text("Close"), // *** Get button text from translation
                        cssClass: '.panel-titlebar-close',
                        icon: 'fa-close',
                        onClick: () => {
                            window.location.href = '/';
                            return false;
                        },
                    }
                );            
                
			// button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
			return button;
		}
    }
}